import { render, staticRenderFns } from "./About.vue?vue&type=template&id=603a0f1b&scoped=true&"
import script from "./About.vue?vue&type=script&lang=ts&"
export * from "./About.vue?vue&type=script&lang=ts&"
import style0 from "./About.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./About.vue?vue&type=style&index=1&id=603a0f1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603a0f1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('603a0f1b', component.options)
    } else {
      api.reload('603a0f1b', component.options)
    }
    module.hot.accept("./About.vue?vue&type=template&id=603a0f1b&scoped=true&", function () {
      api.rerender('603a0f1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/about/About.vue"
export default component.exports